import {Pipe, PipeTransform} from '@angular/core';
import {Store} from '@ngxs/store';
import {JobType} from '../../models/pos/jobType.model';
import {Job} from '../../models/pos/job.model';
import {PosState} from '../../state/pos.state';
import {TypeNameUtils} from '../../utils/typeNameUtils';
import {InvoiceNumberPipe} from '../invoice-number.pipe';

@Pipe({
  standalone: false,
  name: 'job'
})
export class JobResolvePipe implements PipeTransform {
  private readonly numberPipe: InvoiceNumberPipe = new InvoiceNumberPipe();

  constructor(private store: Store) {
  }

  transform(value: string, type: JobType): string {
    const jobs: Partial<Job>[] = this.store.selectSnapshot(PosState.jobs)(type);

    if (value === null || value === undefined || value === '' || jobs?.length === 0) {
      return null;
    }
    const job = jobs.find(j => j.id === value);
    if (job) {
      return TypeNameUtils.getTypeNameSingular(type) + ' #' + this.numberPipe.transform(job.number);
    }
    return null;
  }

}
